import React from "react"
import { Grid, makeStyles, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import SwitchComponent from "./SwitchComponent";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
	title: {
		fontWeight: 'bold',
	},
	switchText: {
		fontSize: 12,
	},
	switchGrid: {
		[theme.breakpoints.down('xs')]: {
			marginTop: theme.spacing(1),
		}
	},
	desc: {
		marginTop: theme.spacing(1),
	}
}));

const SwitcherComponent = ({
	title,
	desc,
	activeTitle,
	disableTitle,
	disabled,
	active,
	handleChange = () => { },
}) => {
	const classes = useStyles();
	const { t } = useTranslation();
	return (
		<Grid className={classes.box} container justify="space-between">
			<Grid item sm={6} xs={6}>
				<Typography className={classes.title}>{title}</Typography>
			</Grid>
			<Grid item sm={6} xs={6}>
				<Grid component="label" container alignItems="center" justify="flex-end"  spacing={1} className={classes.switchGrid}>
					<Grid item>
						<Typography className={classes.switchText}>{disableTitle || t('buttons.disable_switch')}</Typography>
					</Grid>
					<Grid item>
						<SwitchComponent checked={active} onChange={handleChange} name="checkedC" disabled={disabled} />
					</Grid>
					<Grid item>
						<Typography className={classes.switchText}>{activeTitle || t('buttons.active_switch')}</Typography>
					</Grid>
				</Grid>
			</Grid>
			<Grid item xs={12}>
				<Typography className={classes.desc}>{desc}</Typography>
			</Grid>
		</Grid>
	);
};

SwitcherComponent.propTypes = {
	name: PropTypes.string,
};
export default React.memo(SwitcherComponent);